import { styled, Box } from '@withjoy/joykit';

export const FrameWrap = styled(Box)`
  display: flex;
`;
